import React from 'react';

const TermsAndServices: React.FC = () => {
  return (
    <div className="min-h-screen bg-midnight py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-6xl font-serif font-bold mb-12 text-center">Terms & Services</h1>
        
        <div className="prose prose-invert max-w-none space-y-8 text-gray-400">
          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and using AstroVidya.net, operated by Boomtech Solution Private Limited ("we," "us," or "our"), you agree to be bound by these Terms and Services. If you do not agree to these terms, please do not use our website or services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">2. Services Provided</h2>
            <p>
              AstroVidya.net provides astrological readings, reports, and consultation services. These services are for entertainment and spiritual guidance purposes only. We do not guarantee the accuracy or outcomes of any astrological predictions or advice.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">3. User Responsibilities</h2>
            <p>
              You are responsible for providing accurate birth details (date, time, and place) for your readings. You must be at least 18 years old to use our services or have parental consent.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">4. Intellectual Property</h2>
            <p>
              All content on AstroVidya.net, including text, graphics, logos, and reports, is the property of Boomtech Solution Private Limited and is protected by copyright and other intellectual property laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">5. Limitation of Liability</h2>
            <p>
              Boomtech Solution Private Limited shall not be liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use our services. Our astrological advice should not be used as a substitute for professional medical, legal, or financial advice.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">6. Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with the laws of India. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in India.
            </p>
          </section>

          <div className="pt-12 border-t border-white/10 text-center">
            <p className="text-xs text-gray-500 italic">Last Updated: March 31, 2026</p>
            <p className="text-xs text-gray-500 mt-2">© 2026 Boomtech Solution Private Limited. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndServices;
